import {useEffect, useState} from "react";
import {Button, Col, Form} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {v4 as uuidv4} from "uuid";
import {addKlausurDummy} from "../../actions/currentKlausur";
import {translate} from "../../components/Language/Translate";
import Spinner from "../../components/Spinner";
import {dateFormats} from "../../helpers/Date";
import {handleSaveProject} from "../../helpers/saveProject";
import FormField from "../FormField";
import FormValidation from "../Validation/FormValidation";
import KlausurSchema from "./KlausurSchema";

const KlausurNew = ({setView}) => {
  const [variables, setVariables] = useState({});
  const [fieldSettings, setFieldSettings] = useState({});
  const [fieldErrors, setFieldErrors] = useState({});
  const [serverError, setServerError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const currentUser = useSelector(st => st.currentUser);
  // const currentKlausur = useSelector((st) => st.currentKlausur);
  const companies = useSelector(st => st.companies);
  const schueler = useSelector(st => st.schueler);
  const dispatch = useDispatch();
  const land = companies.find(c => c.id === parseInt(variables.companyId))?.land;

  useEffect(() => {
    const fetch = async () => {
      const schema = new KlausurSchema(companies, currentUser);
      const vars = {};
      Object.keys(schema.fields).forEach(k => (vars[k] = schema.fields[k].initialValue || ""));
      const fields = schema.getFields(vars);
      setFieldSettings({...fields});
      setVariables({...vars});
      (() => setIsLoading(false))();
    };
    if (isLoading) fetch();
  }, [isLoading, companies, currentUser]);

  useEffect(() => {
    const schema = new KlausurSchema(companies, currentUser);
    // console.log({ schema });
    setFieldSettings(fs => {
      return {...schema.getFields(variables)};
    });
  }, [variables, setFieldSettings, companies, currentUser]);

  useEffect(() => {
    if (!variables.prozentAfb1 || !variables.prozentAfb2) return;
    setVariables(vars => {
      return {
        ...vars,
        prozentAfb3: 100 - variables.prozentAfb1 - variables.prozentAfb2
      };
    });
  }, [variables.prozentAfb1, variables.prozentAfb2]);
  useEffect(() => {
    if (variables.pruefungsart?.includes("a") && variables.sprachverwendung)
      setVariables(vars => {
        return {...vars, sprachverwendung: 15};
      });
  }, [variables.pruefungsart, variables.sprachverwendung]);
  useEffect(() => {
    console.log({land, fieldSettings});
    if (variables.pruefungsart?.includes("a") && land !== "Brandenburg")
      setFieldSettings(fs => {
        return {
          ...fs,
          gutachter: {
            ...fs.gutachter,
            validation: {minLength: 1},
            required: true
          }
        };
      });
  }, [variables]);

  if (isLoading) return <Spinner />;

  const resetInactiveVarsToInitialValue = () => {
    const schema = new KlausurSchema(companies, currentUser);
    const _allFields = schema.fields;
    const _allKeys = Object.keys(_allFields);
    const _activeKeys = Object.keys(fieldSettings);
    const _inactiveKeys = _allKeys.filter(k => !_activeKeys.includes(k));
    const _vars = {...variables};
    // console.log({ _allKeys, _activeKeys, _inactiveKeys, _vars });
    _inactiveKeys.forEach(k => {
      // console.log(k, _allFields[k], _allFields[k]?.initialValue);
      _vars[k] = schema.getEmpty(_vars[k]);
    });
    return _vars;
  };

  const handleSubmit = async e => {
    e.preventDefault();
    dateFormats();
    const formValidation = new FormValidation({
      fieldSettings,
      variables,
      setFieldErrors
    });
    if (!formValidation.valid) return;
    const cleanVars = resetInactiveVarsToInitialValue();
    const data = {
      ...cleanVars,
      id: uuidv4(),
      createdAt: new Date().toISOString(),
      createdBy: currentUser.username
    };
    console.log({data});
    dispatch(addKlausurDummy(data));
    setTimeout(() => handleSaveProject(data, companies, schueler), 1000);
    // await handleSaveProject(currentKlausur, companies, schueler);
  };

  const props = {
    fieldSettings,
    variables,
    setVariables,
    fieldErrors,
    setFieldErrors,
    serverError,
    setServerError
  };
  console.log({props});
  console.log({schueler, companies, variables, land});

  return (
    <div className="m-2 p-3" style={{border: "1px solid grey", borderRadius: "5px"}}>
      <Form.Row className="row row-eq-height">
        {Object.values(fieldSettings).map(lf => (
          <Col key={lf.name} id={lf.name} className={`col-${lf.col}`}>
            <FormField props={{...props, name: lf.name}} />
          </Col>
        ))}
      </Form.Row>
      <Form.Row>
        <Col>
          <Button block className="btn btn-outline-dark" onClick={handleSubmit}>
            {translate("Submit")}
          </Button>
        </Col>
        <Col>
          <Button block className="btn btn-secondary" onClick={() => setView("buttons")}>
            {translate("Cancel")}
          </Button>
        </Col>
      </Form.Row>
    </div>
  );
};
export default KlausurNew;
